// Convert string to utf-8 before encoding to base64
// To support strings that have 2 byte utf16 encodings, anyone
// receiving this base64 string will need to decode this using
// decodeURIComponent after converting from base64 with atob
// e.g.  decodeURIComponent(escape(atob(encodedString)));
//
// Bare use of btoa and atob cannot handle 2 byte utf16 characters
// and raises an error if they are provided.
export default string => {
  if (typeof string !== 'string') {
    throw new TypeError('encodeBase64String requires its argument be a string');
  }

  return btoa(unescape(encodeURIComponent(string)));
};
